<template>
  <div class="menu">
    <div class="menu__hero-img"></div>
    <div class="menu__content">
      <div class="menu__content__heading">
        <h1>Menu naszej restauracji</h1>
      </div>

      <div class="menu__content__main">
        <div class="menu__content__main__filters">
          <ul class="menu__content__main__filters__list">
            <li>
              <label><input
                type="radio"
                name="dishType"
                class="starter"
                @click="changeDisplayedDishType('starter')"
                checked>Przystawki</label>
            </li>

            <li>
              <label><input
                type="radio"
                name="dishType"
                class="soup"
                @click="changeDisplayedDishType('soup')">Zupy</label>
            </li>

            <li>
              <label><input
                type="radio"
                class="mainCourse"
                name="dishType"
                @click="changeDisplayedDishType('veganDish')">Dania wegetariańskie</label>
            </li>

            <li>
              <label><input
                type="radio"
                class="mainCourse"
                name="dishType"
                @click="changeDisplayedDishType('meatDish')">Dania mięsne</label>
            </li>

            <li>
              <label><input
                type="radio"
                class="mainCourse"
                name="dishType"
                @click="changeDisplayedDishType('fish')">Ryby</label>
            </li>

            <li>
              <label><input
                type="radio"
                class="mainCourse"
                name="dishType"
                @click="changeDisplayedDishType('salad')">Sałaty</label>
            </li>

            <li>
              <label><input
                type="radio"
                class="mainCourse"
                name="dishType"
                @click="changeDisplayedDishType('pasta')">Pasty</label>
            </li>

            <li>
              <label><input
                type="radio"
                name="dishType"
                class="dessert"
                @click="changeDisplayedDishType('dessert')">Desery</label>
            </li>
          </ul>
        </div>

        <div class="menu__content__main__dishes">
          <div class="menu__content__main__dishes__dish"
               v-for="dish in dishes"
               :class="'dish-' + dish.type">
            <div class="top-content">
              <p class="top-content__dish-name">{{ dish.name }}</p>
              <p class="top-content__dish-price">{{ dish.price }} PLN</p>
            </div>
            <div class="bottom-content">
              <p class="bottom-content__dish-description">{{ dish.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { db } from '../firebase'

export default {
  name: 'Menu',
  data () {
    return {
      dishes: []
    }
  },
  async created () {
    await db.collection("dishes").doc("normal").get().then(doc => {
      this.dishes = doc.data();
    })

    document.querySelectorAll(`.dish-starter`).forEach(dish => {
      dish.classList.add('menu__content__main__dishes__dish--visible')
    })
  },
  methods: {
    changeDisplayedDishType (typeOfDish) {
      this.hideAllActiveDishes()

      document.querySelectorAll(`.dish-${typeOfDish}`).forEach(dish => {
        dish.classList.add('menu__content__main__dishes__dish--visible')
      })
    },
    hideAllActiveDishes () {
      document.querySelectorAll(`.menu__content__main__dishes__dish--visible`).forEach(dish => {
        dish.classList.remove('menu__content__main__dishes__dish--visible')
      })
    }
  }
}
</script>
